import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ButtonPrimary from "../../buttons/ButtonPrimary";
import { setmessage } from "../../../redux/actions/styles";

const PopupMessage = () => {
  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.styles);

  if (!message) {
    return null;
  }
  return (
    <div
      className={`popup-message ${message ? "popup-message-visible" : ""}`}
      onClick={() => dispatch(setmessage(null))}
    >
      <div className="container" onClick={(e) => e.stopPropagation()}>
        <div className="flex g-1 mb-2">
          {message.type === "success" ? (
            <CheckCircleOutlineSharpIcon className="green" />
          ) : message.type === "info" ? (
            <InfoOutlinedIcon className="info" />
          ) : message.type === "error" ? (
            <CancelOutlinedIcon className="red" />
          ) : null}
          <h3>{message.title}</h3>
        </div>
        <p className="message mb-3">{message.message}</p>
        <div className="flex-je-ac">
          <ButtonPrimary text="Close" onClick={() => dispatch(setmessage(null))} size="sm" variant="primary" />
        </div>
      </div>
    </div>
  );
};

export default PopupMessage;
